import { cfdiAxios } from '@/services/Axios';

export default {
  async fiscalRegimeList({ rfc = '', query = '' } = {}) {
    const { data } = await cfdiAxios.get('/sat-regimen/list', {
      params: { rfc, query },
    });
    return data;
  },
  async usoCfdiList({ regimen = '', query = '' } = {}) {
    const { data } = await cfdiAxios.get('/sat-uso-cfdi/list', {
      params: { regimen, query },
    });
    return data;
  },
};
